import React from 'react';
import './button.css';

interface ButtonProps {
  onClick?: () => void;
  label: string;
  color: 'primary' | 'secondary' | 'danger' | 'green';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: React.ReactElement; // Ajout de la propriété icon
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  label,
  color,
  type = 'button',
  disabled = false,
  icon,
}) => {
  return (
    <button
      className={`btn btn-${color}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {icon && <span className='btn-icon'>{icon}</span>}{' '}
      {/* Affiche l'icône si elle est présente */}
      {label}
    </button>
  );
};

export default Button;
